// extracted by mini-css-extract-plugin
export default {"departments":"bH-z","departmentHeading":"cH-z","departmentSection":"dH-z","departmentName":"eH-z","departmentLink":"fH-z","expandIcon":"gH-z"};